import { render } from "./index.vue?vue&type=template&id=fae9c5aa&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=fae9c5aa&lang=scss"
import "./index.vue?vue&type=style&index=1&id=fae9c5aa&lang=scss&scoped=scoped"

import exportComponent from "D:\\工作项目\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae9c5aa"]])

export default __exports__